module.exports = __webpack_public_path__ + "img/geo-zones-3-mobile.e54c4ffe.gif";